import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/routes/guards';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const HomePage = lazy(() => import('./pages/Home'));
const StartOnDutyPage = lazy(() => import('./pages/StartOnDuty'));
const PaymentPage = lazy(() => import('./pages/Payment'));
const TriagePage = lazy(() => import('./pages/Triage'));
const WaitingPage = lazy(() => import('./pages/Waiting'));
const VideoCallPage = lazy(() => import('./pages/VideoCall'));
const ClosingPage = lazy(() => import('./pages/Closing'));

const patient = (el: React.ReactNode) => <RequireAuth registered>{el}</RequireAuth>;

/** Área do paciente: home (T-09) e plantão site (F-03 · T-10..T-14). A sala /atendimento/:id serve também a consulta privada. */
const routes: RouteObject[] = [
  { path: '/inicio', element: patient(<HomePage />) },
  { path: '/plantao', element: patient(<StartOnDutyPage />) },
  { path: '/plantao/:id/pagamento', element: patient(<PaymentPage />) },
  { path: '/plantao/:id/triagem', element: patient(<TriagePage />) },
  { path: '/plantao/:id/espera', element: patient(<WaitingPage />) },
  { path: '/atendimento/:id', element: patient(<VideoCallPage />) },
  { path: '/atendimento/:id/encerrado', element: patient(<ClosingPage />) },
];
export default routes;
